module.exports = require("$");